<p>
  demo from
  <b>shared</b>
  works!
</p>
<p>{{ name }}</p>

<p>{{ token }}</p>
